<template>
  <div class="animated fadeIn">
    <basic-heading title="New Turnaround">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add turnaround'">
      <template #gated-content>
        <turnaround-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TurnaroundForm from "@/components/lab/turnaround/TurnaroundForm";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { turnaroundNotifications } from "@/shared/notifications";

const TurnaroundRepository = LabRepositoryFactory.get("turnaround");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TurnaroundAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TurnaroundForm,
  },
  data() {
    return {
      laboratory_id: this.$store.getters.getLaboratoryContext.id || null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/turnarounds",
            title: "Turnaround list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      const payload = {
        ...form_data,
        laboratory_id: this.laboratory_id,
      };
      try {
        const { data } = await TurnaroundRepository.create(payload);

        this.addSuccess();
        this.$router.push(`/turnarounds/${data.id}`);
      } catch ({ response }) {
        this.addFail();
      }
    },
  },
  notifications: turnaroundNotifications,
};
</script>
